import { useEffect, useRef, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import { setAuthToken, api, configureApiAuth } from "../lib/api";
import { useAuthStore } from "../stores/auth.store";



export const useAuthSync = () => {
  const { getToken, isSignedIn, signOut } = useAuth();
  const orgLoaded = useRef(false);
  const [ready, setReady] = useState(false);
  const [clientBlocked, setClientBlocked] = useState(false);

  useEffect(() => {
    if (!isSignedIn) {
      setAuthToken(null);
      orgLoaded.current = false;
      useAuthStore.getState().reset();
      setReady(false);
      setClientBlocked(false);
      return;
    }

    configureApiAuth(getToken);

    let cancelled = false;
    const sync = async () => {
      const token = await getToken();
      if (cancelled) return;
      setAuthToken(token);
      setReady(true);

      if (token) {
        try {
          const { data } = await api.get("/auth/me");
          if (!cancelled) {
            if (data.features) {
              useAuthStore.getState().setFeatures(data.features);
            }
            if (!orgLoaded.current) {
              if (data.user) {
                useAuthStore.getState().setUser(data.user);
              }
              if (data.org) {
                useAuthStore.getState().setOrg(data.org);
              }
              orgLoaded.current = true;
            }
          }
        } catch (err: unknown) {
          if (!cancelled) {
            const e = err as {
              response?: { status?: number; data?: { message?: string } };
            };
            const status = e?.response?.status;
            const msg = e?.response?.data?.message ?? "";
            if ((status === 401 || status === 403) && msg.includes("client")) {
              setClientBlocked(true);
              setTimeout(() => signOut(), 2500);
            }
          }
        }
      }
    };
    sync();

    const interval = setInterval(sync, 50_000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [getToken, isSignedIn, signOut]);

  if (clientBlocked) return "client_blocked" as const;
  return ready;
}
